var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5296 4.72945C12.8469 5.03273 12.8469 5.48766 12.5296 5.79094L8.24736 9.80945C7.50722 10.5171 6.37056 9.45562 7.13714 8.74796L9.64836 6.37224C9.85983 6.17005 9.78053 6.01841 9.48976 6.01841L0.793016 6.01841C0.34364 6.01841 -6.22799e-08 5.68985 -5.71564e-08 5.2602C-5.20328e-08 4.83054 0.34364 4.50199 0.793016 4.50199L9.46332 4.50199C9.75409 4.50199 9.8334 4.35035 9.62192 4.14816L7.11071 1.77243C6.37056 1.06477 7.48078 -0.0219959 8.22093 0.71094L12.5296 4.72945Z",
    fill: "#6AA442"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenArrow);
export default __webpack_public_path__ + "static/media/green-arrow.3a4e7b4c5ca57813b1aee3fe63a2d543.svg";
export { ForwardRef as ReactComponent };